


















































































































































































































































import {Component, Prop, Vue, Watch} from 'vue-property-decorator'
import {Getter} from 'vuex-class'
import _ from 'lodash'
import moment, {Moment} from 'moment'
import {$, Dictionary, ID, successAndPush} from 'simpli-web-sdk'
import {AppConfig} from '@/config/app.config'
import {DeliveryAddressOption} from '@/enums/DeliveryAddressOption'
import ItEnderecoFormSection from '@/components/itrack/ItEnderecoFormSection.vue'
import Carga from '@/model/resource/Carga'
import Endereco from '@/model/resource/Endereco'
import CargaDanfeRequest from '@/model/request/CargaDanfeRequest'
import Responsavel from '@/model/resource/Responsavel'
import * as Helper from '@/helpers'
import SearchDestinatario from '@/components/SearchDestinatario.vue'
import AutoCompleteDestinatario from '@/model/resource/AutoCompleteDestinatario'

enum Type {
  COM_DANFE = 'full',
  SEM_DANFE = 'lite',
}

const metaInfo = () => ({
  title: $.t('view.persist.deliveryPersist.titleDefault'),
})

@Component({
  metaInfo,
  components: {SearchDestinatario, ItEnderecoFormSection},
})
export default class DeliveryPersistView extends Vue {
  @Prop({type: [String, Number]}) id?: ID
  @Prop({type: String}) type?: Type

  @Getter('auth/responsavel') user!: Responsavel

  AppConfig = AppConfig
  DeliveryAddressOption = DeliveryAddressOption
  Type = Type

  selectedType: Type | null = null

  carga = new Carga() as Carga

  dataFromDanfe = false
  incompleteCnpj = false
  incompleteCep = false
  exportacao = Helper.getClienteExportacao()
  showNotificacaoSmsAtlas = Helper.getShowNotificacaoSmsAtlas()
  showNotificationEmailAtlas = Helper.getShowNotificacaoEmailAtlas()
  showAgcoNotification = Helper.isAGCO() && this.editMode
  autofocus: boolean | null = null
  firstRun: boolean = true
  bloquearEdicaoTransportadorEmbarcador = this.type === Type.SEM_DANFE && Helper.isSpinel()

  uid = Helper.uid()

  Helper = Helper
  destinatario = new AutoCompleteDestinatario()

  populateByCnpjDebounced = _.debounce((cnpj: string) => this.carga.populateByCnpj(cnpj), 1000)

  customEmbarcadorErrorMessage: Dictionary<string | null> = {
    razaoSocial: null,
    nomeFantasia: null,
    cnpj: null,
    telefone: null,
    cep: null,
    logradouro: null,
    bairro: null,
    cidade: null,
    uf: null,
  }

  customDestinatarioErrorMessage: Dictionary<string | null> = {
    nome: null,
    cpfCnpj: null,
    telefone: null,
    email: null,
    cep: null,
    logradouro: null,
    bairro: null,
    cidade: null,
    uf: null,
  }

  get editMode() {
    return !!this.id
  }

  get headerFields() {
    if (this.selectedType === Type.SEM_DANFE) {
      return AppConfig.fieldsToInput.deliveryPersist.CargaSemDanfe
    }
    return AppConfig.fieldsToInput.deliveryPersist.CargaComDanfe
  }

  cnpjDestinatarioFirstDigits: string | null = null
  cnpjDestinatarioLastDigits: string | null = null
  get cnpjDestinatario() {
    if (!this.cnpjDestinatarioFirstDigits || !this.cnpjDestinatarioLastDigits) return null
    if (this.cnpjDestinatarioFirstDigits.length !== 5) return null
    if (this.cnpjDestinatarioLastDigits.length !== 9) return null

    return `${this.cnpjDestinatarioFirstDigits}${this.cnpjDestinatarioLastDigits}`
  }

  get formattedCnpjDestinatarioLastDigits() {
    const cnpj = `00000${this.cnpjDestinatarioLastDigits}`
    return $.filter.cnpj(cnpj).slice(6)
  }

  @Watch('cnpjDestinatario')
  cnpjDestinatarioEvent(val: string | null) {
    if (val) {
      this.carga.destinatario.cpfCnpj = val
    } else {
      this.carga.destinatario.cpfCnpj = ''
    }
  }

  refreshLocal() {
    this.uid = Helper.uid()
  }

  populateByCnpj(cnpj: string) {
    if (this.editMode && this.firstRun) {
      this.firstRun = false
      return
    }
    if (cnpj.length === 14) {
      this.populateByCnpjDebounced(cnpj)
    } else {
      this.populateByCnpjDebounced.cancel()
    }
  }

  @Watch('carga.embarcador.responsavel.razaoSocial')
  embarcadorRazaoSocialEvent(val: string | null) {
    if (!val) {
      this.customEmbarcadorErrorMessage.razaoSocial = this.$t('system.error.invalidField') as string
    } else {
      this.customEmbarcadorErrorMessage.razaoSocial = null
    }
  }

  @Watch('carga.embarcador.responsavel.cnpj')
  embarcadorCnpjEvent(val: string | null) {
    let message: string | null = this.$t('system.error.invalidField') as string

    if (val != null && val.length > 0) {
        message = null
    }

    this.customEmbarcadorErrorMessage.cnpj = message
  }

  @Watch('carga.embarcador.endereco.cep')
  embarcadorCepEvent(val: string | null) {
    if (!val) {
      this.customEmbarcadorErrorMessage.cep = this.$t('system.error.invalidField') as string
    } else {
      this.customEmbarcadorErrorMessage.cep = null
    }
  }

  @Watch('carga.embarcador.endereco.logradouro')
  embarcadorLogradouroEvent(val: string | null) {
    if (!val) {
      this.customEmbarcadorErrorMessage.logradouro = this.$t('system.error.invalidField') as string
    } else {
      this.customEmbarcadorErrorMessage.logradouro = null
    }
  }

  @Watch('carga.embarcador.endereco.bairro')
  embarcadorBairroEvent(val: string | null) {
    if (!val) {
      this.customEmbarcadorErrorMessage.bairro = this.$t('system.error.invalidField') as string
    } else {
      this.customEmbarcadorErrorMessage.bairro = null
    }
  }

  @Watch('carga.embarcador.endereco.cidade')
  embarcadorCidadeEvent(val: string | null) {
    if (!val) {
      this.customEmbarcadorErrorMessage.cidade = this.$t('system.error.invalidField') as string
    } else {
      this.customEmbarcadorErrorMessage.cidade = null
    }
  }

  @Watch('carga.embarcador.endereco.uf')
  embarcadorUfEvent(val: string | null) {
    if (!val) {
      this.customEmbarcadorErrorMessage.uf = this.$t('system.error.invalidField') as string
    } else {
      this.customEmbarcadorErrorMessage.uf = null
    }
  }

  @Watch('carga.destinatario.nome')
  destinatarioNomeEvent(val: string | null) {
    if (!val || /\*\*\*/.test(val)) {
      this.customDestinatarioErrorMessage.nome = this.$t('system.error.invalidField') as string
    } else {
      this.customDestinatarioErrorMessage.nome = null
    }
  }

  @Watch('carga.destinatario.cpfCnpj')
  destinatarioCpfCnpjEvent(val: string | null) {
    if (!val || !/(^\d{11}$)|(^\d{14}$)/.test(val)) {
      if (val && /^\d{9}$/.test(val)) {
        this.customDestinatarioErrorMessage.cpfCnpj = this.$t('system.error.incompleteCnpj') as string
      } else {
        this.customDestinatarioErrorMessage.cpfCnpj = this.$t('system.error.invalidField') as string
      }
    } else {
      this.customDestinatarioErrorMessage.cpfCnpj = null
    }

    if (val) {
      this.populateByCnpj(val)
    }
  }

  @Watch('carga.destinatario.endereco.cep')
  destinatarioCepEvent(val: string | null) {
    if (!val) {
      this.customDestinatarioErrorMessage.cep = this.$t('system.error.invalidField') as string
    } else {
      this.customDestinatarioErrorMessage.cep = null
    }
  }

  @Watch('carga.destinatario.endereco.logradouro')
  destinatarioLogradouroEvent(val: string | null) {
    if (!val) {
      this.customDestinatarioErrorMessage.logradouro = this.$t('system.error.invalidField') as string
    } else {
      this.customDestinatarioErrorMessage.logradouro = null
    }
  }

  @Watch('carga.destinatario.endereco.bairro')
  destinatarioBairroEvent(val: string | null) {
    if (!val) {
      this.customDestinatarioErrorMessage.bairro = this.$t('system.error.invalidField') as string
    } else {
      this.customDestinatarioErrorMessage.bairro = null
    }
  }

  @Watch('carga.destinatario.endereco.cidade')
  destinatarioCidadeEvent(val: string | null) {
    if (!val) {
      this.customDestinatarioErrorMessage.cidade = this.$t('system.error.invalidField') as string
    } else {
      this.customDestinatarioErrorMessage.cidade = null
    }
  }

  @Watch('carga.destinatario.endereco.uf')
  destinatarioUfEvent(val: string | null) {
    if (!val) {
      this.customDestinatarioErrorMessage.uf = this.$t('system.error.invalidField') as string
    } else {
      this.customDestinatarioErrorMessage.uf = null
    }
  }

  validateEmbarcador() {
    const {razaoSocial, nomeFantasia, cnpj} = this.carga.embarcador.responsavel
    const {cep, logradouro, bairro, cidade, uf} = this.carga.embarcador.endereco

    this.embarcadorRazaoSocialEvent(razaoSocial)
    this.embarcadorCnpjEvent(cnpj)
    this.embarcadorCepEvent(cep)
    this.embarcadorLogradouroEvent(logradouro)
    this.embarcadorBairroEvent(bairro)
    this.embarcadorCidadeEvent(cidade)
    this.embarcadorUfEvent(uf)

    if (!cep) {
      this.incompleteCep = true
    }
  }

  validateDestinatario() {
    const {nome, cpfCnpj} = this.carga.destinatario
    const {cep, logradouro, bairro, cidade, uf} = this.carga.destinatario.endereco

    this.destinatarioNomeEvent(nome)
    this.destinatarioCpfCnpjEvent(cpfCnpj)
    this.destinatarioCepEvent(cep)
    this.destinatarioLogradouroEvent(logradouro)
    this.destinatarioBairroEvent(bairro)
    this.destinatarioCidadeEvent(cidade)
    this.destinatarioUfEvent(uf)

    if (cpfCnpj.length === 9) {
      this.incompleteCnpj = true
      this.cnpjDestinatarioLastDigits = cpfCnpj
    }
  }

  @Watch('carga.danfe')
  async danfeEvent(val: string | null) {
    const match = val ? val.match(/^\d+$/g) : null
    if (!match) {
      await this.$nextTick()
      const danfe = val ? val.slice(0, -1) : ''
      this.carga.danfe = `${danfe}`
      return
    }

    if (this.editMode) return
    if (!val || val.length !== 44) return

    this.dataFromDanfe = true
    this.autofocus = false // prevent to autofocus after the population

    try {
      await this.carga.populateByDanfe()
      this.refreshLocal()
      this.validateEmbarcador()
      this.validateDestinatario()
    } catch (e) {
      this.dataFromDanfe = false
    }

    await Helper.sleep(1000)
    this.autofocus = null
  }

  @Watch('carga.addressOption')
  deliveryAddressOptionEvent(val: DeliveryAddressOption) {
    if (val === DeliveryAddressOption.ANOTHER_ADDRESS && this.carga.endereco === null) {
      this.carga.endereco = new Endereco()
    }
  }

  created() {
    this.selectedType = this.type || null

    if (!this.id && !Object.values(Type).includes(this.type)) {
      Helper.push('/manage/delivery/register')
    }
  }

  async mounted() {

    await this.carga.allMotoristaFiltro.query()

    if (this.id) {
      await this.carga.find(this.id)
      this.selectedType = this.carga.possuiDanfe ? Type.COM_DANFE : Type.SEM_DANFE

      if (this.carga.endereco && this.carga.endereco.$id) {
        this.carga.addressOption = DeliveryAddressOption.ANOTHER_ADDRESS
      } else {
        this.carga.addressOption = DeliveryAddressOption.RECEIVER_ADDRESS
      }
    }

    if (this.bloquearEdicaoTransportadorEmbarcador) {
        this.populateSpinelTransportadorEmbarcador()
    }

    $.await.done('findCarga')
  }

  populateSpinelTransportadorEmbarcador() {
      this.carga.embarcador.responsavel.cnpj = Helper.SPINEL_INFO.cnpj
      this.carga.embarcador.responsavel.razaoSocial = Helper.SPINEL_INFO.razaoSocial
      this.carga.embarcador.endereco.cep = Helper.SPINEL_INFO.endereco.cep
      this.carga.embarcador.endereco.logradouro = Helper.SPINEL_INFO.endereco.logradouro
      this.carga.embarcador.endereco.nro = Helper.SPINEL_INFO.endereco.nro
      this.carga.embarcador.endereco.bairro = Helper.SPINEL_INFO.endereco.bairro
      this.carga.embarcador.endereco.cidade = Helper.SPINEL_INFO.endereco.cidade
      this.carga.embarcador.endereco.uf = Helper.SPINEL_INFO.endereco.uf
      this.carga.embarcador.endereco.complemento = Helper.SPINEL_INFO.endereco.complemento
      this.validateEmbarcador()

      this.carga.transportador.responsavel = this.carga.embarcador.responsavel
      this.carga.transportador.endereco = this.carga.embarcador.endereco
  }

  async persist() {
    await Helper.sleep(1000)

    if (this.carga.addressOption === DeliveryAddressOption.RECEIVER_ADDRESS) {
      this.carga.endereco = null
    }

    this.carga.possuiDanfe = this.selectedType === Type.COM_DANFE

    if (this.carga.dataPrevisao) {
      const dataPrevisao: Moment = moment(this.carga.dataPrevisao)

      if (dataPrevisao.hour() === 0 && dataPrevisao.minute() === 0) {
        this.carga.dataPrevisao = dataPrevisao.set('hour', 23).set('minute', 59).format()
      }
    }

    if (!this.dataFromDanfe) {
      if (this.selectedType === Type.COM_DANFE) {
        await this.carga.validate()
      }

      if (!this.editMode) {
        await this.carga.embarcador.endereco.validate()
        await this.carga.transportador.endereco.validate()
        if (this.carga.endereco) {
          await this.carga.endereco.validate()
        }
      }
      await this.carga.destinatario.endereco.validate()
    }

    /*try {
      if (!this.editMode) {
        await this.carga.embarcador.endereco.populateLatLng()
        await this.carga.transportador.endereco.populateLatLng()
        if (this.carga.endereco) {
          await this.carga.endereco.populateLatLng()
        }
      }
      if (!this.user.apiSomenteGoogle) {
        await this.carga.destinatario.endereco.populateLatLng()
      }
    } catch (e) { /!* ignore *!/ }*/

    const request = new CargaDanfeRequest() as CargaDanfeRequest
    request.carga = this.carga
    request.forcar = this.editMode
    request.naoValidar = this.dataFromDanfe

    await this.carga.persistCargaDanfe(request)
    successAndPush('system.success.persist', '/manage/delivery/register')
  }

  @Watch('destinatario', {deep: true})
  completeFields() {
    this.carga.destinatario.nome =  this.destinatario.nome || ''
    this.carga.destinatario.cpfCnpj = this.destinatario.cpfCnpj || ''
    this.carga.destinatario.telefone = this.destinatario.telefone || ''
    this.carga.destinatario.email = this.destinatario.email
    this.carga.destinatario.endereco.logradouro = this.destinatario.logradouro || ''
    this.carga.destinatario.endereco.nro = this.destinatario.numero || ''
    this.carga.destinatario.endereco.bairro = this.destinatario.bairro || ''
    this.carga.destinatario.endereco.cidade = this.destinatario.cidade || ''
    this.carga.destinatario.endereco.uf = this.destinatario.uf
    this.carga.destinatario.endereco.complemento = this.destinatario.complemento || ''
    this.carga.destinatario.endereco.cep = this.destinatario.cep || ''
  }
}
